import React, { useEffect, useState } from "react";
import "./FroalaEditorStyles.scss";
import Froalaeditor from "froala-editor";
import "froala-editor/js/plugins.pkgd.min.js";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import BulbIcon from "../../../Assets/Images/bulbIcon.png";
import AICommentHelper from "../../Components/LineDetails/CommentDetails/AICommentHelper";
import { decodeEntities } from "../../Components/LineDetails/CommentDetails/CommentLibraryHelper";

const FroalaWithoutDropdown = (props) => {
  const {
    categoryName,
    categoryNameFromLocation,
    showAIModal,
    setShowAIModal,
    setCommentText,
    commentTitle,
    showAI,
    editor,
    id,
    onChange,
    editorData,
    onBlur,
    commentData,
    copy,
    froalaConfig,
    toolbarButtonsConfig,
    lineName,
    setEditorContent
  } = props;

  const [state, setState] = useState({
    open: false,
    newOption: "",
    openHelp: false,
    dropdownList: [],
    textfield: false,
    hoverOption: null,
    editedOption: null,
    dialogOptionList: [],
    selectedDropdown: null,
  });
  const { openHelp } = state;

  const handleSelect = (value, currentInputId) => {
    if (!currentInputId) return;
    const inputElement = document.getElementById(currentInputId);
    if (inputElement) {
      inputElement.value = value.replace(/"/g, '&quot;');
    }
    setTimeout(() => {
      const editorInstance = editor?.current?.editor;
      if (editorInstance) {
        let content = editorInstance.html.get();
        const selectRegex = new RegExp(`(<select[^>]*id=["']${currentInputId}["'][^>]*)(>)`, 'i');
        content = content.replace(selectRegex, `$1 value="${value}"$2`);
        const optionRegex = new RegExp(`(<select[^>]*id=["']${currentInputId}["'][^>]*>)([\\s\\S]*?)(</select>)`, 'i');
        content = content.replace(optionRegex, (match, start, options, end) => {
          options = options.replace(/\sselected(=["']?[^"'\s>]+["']?)?/gi, '');
          const updatedOptions = options.replace(
            new RegExp(`(<option[^>]*value=["']${value}["'])`, 'i'),
            `$1 selected`
          );
          return `${start}${updatedOptions}${end}`;
        });
        editorInstance.html.set(content);
        editorInstance.events.trigger('contentChanged');
      }
    }, 10);
    let updatedDropdownList = [];
    updatedDropdownList = editorData?.dropdownList?.map((dropdown) =>
      dropdown?.dropdown_uuid === currentInputId
        ? { ...dropdown, selected_value: value }
        : dropdown
    );
    setEditorContent((prevState) => ({ ...prevState, dropdownList: updatedDropdownList }));
  };

  useEffect(() => {
    const editorInstance = editor?.current?.editor;
    let editorContent = editorInstance?.html?.get();
    let modifiedHtml;
    const replacePlaceholdersWithDropdowns = () => {
      const dropdowns = commentData?.comment_dropdowns;
      const regexPlainDropdown = /\[dropdown ([a-f0-9\-]{36})\]/gi;
      if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = commentData?.comment_text;
        var placeholderRegex = /\[dropdown\s([a-f0-9-]+)\]/g;
        const textToReplace = commentData?.comment_text;
        modifiedHtml = textToReplace?.replace(placeholderRegex, (match, dropdownId) => {
          let dropdown
          dropdown = commentData?.comment_dropdowns?.find((item) => item?.dropdown_uuid === dropdownId);
          if (dropdown) {
            let optionsHtml = dropdown?.dropdowns_values?.length === 0
              ? ""
              : dropdown?.dropdowns_values?.filter((obj) => !obj?.toUpperCase().includes("XXX"))
                ?.map((value) => {
                  const isSelected = value?.trim() === dropdown?.selected_value?.trim();
                  return `<option title="${value}" value="${value}" ${isSelected ? " selected" : ""}>${value}</option>`;
                })
                .join("");
            const editButton =
              id === "intro-text-editor"
                ? `<button id="dropdownButton${dropdownId}" contenteditable="false" name="${dropdownId}" type="button" style="background-color: #f1f9fe;
                                           width: 24px;
                                           height: 24px;
                                           padding: 0px;
                                           color: #4282e2;
                                           border-radius: 4px 0px 0px 4px;
                                           border: 1px solid #4282e2;
                                           position: relative;
                                           transform: scaleX(-1);
                                           font-size: 17px;
                                           margin-left: -4px;
                                           display: inline-flex;
                                           vertical-align: middle;
                                           top: -1px;">
                                     ✎
                                   </button>`
                : "";
            return `<span contenteditable="false" style="white-space: nowrap;" id="[dropdown ${dropdownId}]" class="${id === "commentText" ? "comment" : "summary"}-dropdown">
                     <select id="${dropdownId}" style="width: 104px;
                             background-color: #f1f9fe;
                             height: 24px;
                             overflow-wrap: break-word;
                             padding: 1px 17px 3px 6px;
                             background-position: right 4px center;
                             background-repeat: no-repeat;
                             background-size: 22px 20px;
                             border-radius: 4px 4px 4px 4px;
                             border: 1px solid #4282e2;
                             appearance: none;
                             -webkit-appearance: none;
                             -moz-appearance: none;
                             font-size: 14px !important;
                             color: #3B3B3B !important;
                             font-style: normal !important;
                             font-weight: 600 !important;
                             max-width: 200px !important;
                             min-width: 104px !important;
                             text-overflow: ellipsis !important;
                             white-space: nowrap !important;
                             width: -webkit-max-content !important;
                             width: max-content !important;
                             background-image: url('data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7%2010L12%2015L17%2010H7Z%22%20fill%3D%22%23777777%22/%3E%3C/svg%3E');"
                             onchange="handleSelect(event, '${dropdownId}')">
                       <option value="-------------">-------------</option>
                       ${optionsHtml}
                     </select>
                      ${editButton}
                   </span>`;
          }
          return match;
        });
        editorData.innerHTML = modifiedHtml;
      } else {
        const regexPlainDropdown = /\[dropdown ([a-f0-9-]+)\]/gi;
        const outputString = editorData?.innerHTML?.replace(regexPlainDropdown, (match, selectId) => {
          return `<select id="${selectId}" class="${id === "intro-text-editor" ? "intro" : id === "commentText" ? "comment" : "summary"}-cl-dropdown"><option>--------------</option></select>`;
        });
        editorData.innerHTML = outputString;
      }
      return decodeEntities(copy ? editorData.innerHTML : editorData.innerHTML?.replace(regexPlainDropdown, ""));
    };
    setTimeout(() => {
      if ((!editorContent || editorContent === undefined || copy) && editorInstance && editorData?.innerHTML) {
        let newHtmlData = replacePlaceholdersWithDropdowns(editorData?.innerHTML);
        editorInstance?.html?.set(id === "non-narrative-comment" ? newHtmlData : editorData?.innerHTML);
      }
    }, 100);
  }, []);

  useEffect(() => {
    const editorInstance = editor?.current?.editor;
    if (!editorInstance) return;
    const handler = (e) => {
      if (e.target.tagName === "SELECT") {
        handleSelect(e.target.value, e.target.id);
      }
    };
    editorInstance.$el.on('change', handler);
    return () => {
      editorInstance.$el.off('change', handler);
    };
  }, [editor, handleSelect]);


  const handleModelChange = (model) => {
    onChange(id, model);
  };

  const openHelpDialog = () => {
    setState((prevState) => ({ ...prevState, openHelp: !openHelp }));
    setShowAIModal(!showAIModal);
  };

  Froalaeditor.DefineIcon("aiHelper", { SRC: BulbIcon, ALT: "Image button", height: 50, width: "50px", template: "image" });
  Froalaeditor.RegisterCommand("aiHelper", {
    title: "AI helper",
    focus: false,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      openHelpDialog();
    },
  });
  const handleFocus = () => {
    setState((prevState) => ({ ...prevState, isFocused: true }));
  };

  const handleBlur = () => {
    setState((prevState) => ({ ...prevState, isFocused: false }));
    const editorInstance = editor.current?.editor;
    const editorContent = editorInstance?.html?.get();
    if (onBlur) {
      setTimeout(() => {
        onBlur(id, editorContent);
      }, 100);
    }
  };

  if (showAI) {
    toolbarButtonsConfig.aiHelper = { buttons: ["aiHelper"], align: "left" };
  }

  const handleSetComment = (values) => {
    const editorInstance = editor.current.editor;
    const cursorPosition = editorInstance.selection.get();
    if (cursorPosition) {
      editorInstance.html.insert(`<div><div>${values}</div></div>`);
    }
  };

  return (
    <div id={id}>
      <FroalaEditor
        id={id}
        ref={editor}
        value={editorData || null}
        onModelChange={handleModelChange}
        config={{
          key: "zEG4iE3C7A8A4C4A3A4aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3A2A1C8C6D4D4C4==",
          spellCheck: true,
          imagePaste: false,
          pastePlain: true,
          pasteDeniedAttrs: ['style', 'class', 'classname'],
          pasteDeniedTags: ['style'],
          wordPasteModal: false,
          placeholderText: " ",
          charCounterCount: false,
          quickInsertEnabled: false,
          pluginsEnabled: ["wordPaste", "spellChecker", "codeBeautifier", "fontFamily", "fontSize", "colors", "align", "lists"],
          toolbarButtons: toolbarButtonsConfig,
          events: {
            focus: handleFocus,
            blur: handleBlur,
          },
          ...froalaConfig,
        }}
      />
      <AICommentHelper
        categoryName={categoryName}
        lineName={lineName}
        categoryNameFromLocation={categoryNameFromLocation}
        showAIModal={showAIModal}
        setShowAIModal={setShowAIModal}
        id={id}
        editor={editor}
        setCommentText={setCommentText}
        commentTitle={commentTitle}
        open={openHelp}
        onClose={openHelpDialog}
        handleSetComment={handleSetComment}
      />
    </div>
  );
};

export default FroalaWithoutDropdown;
